import React from 'react';
import isEmpty from 'lodash/isEmpty';
import capitalize from 'lodash/capitalize';
import { Container, Col, Row } from 'reactstrap';

import { Page, Loading } from '../../../components';
import TransportationList from './TransportationList';
import { appendHoneyGuide } from '../../../lib/utils';
import TransportationSearchFormWrapper from '../Common/TransportationSearchFormWrapper';
import { injectTransportationSearchParams } from '../Common';

function TransportationListScreen(props) {
  const { queryParams } = props;

  if (isEmpty(queryParams)) return <Loading />;

  const { fromLocation, toLocation } = queryParams;

  const title = `Transportation from ${capitalize(fromLocation)} - ${capitalize(toLocation)}`;
  
  return (
    <Page title={appendHoneyGuide(title)}>
      <Container>
        <Row>
          <Col xs="12" lg="3" xl="3">
            <TransportationSearchFormWrapper forMobile />
            <TransportationSearchFormWrapper />
          </Col>
          <TransportationList title={title}/>
        </Row>
      </Container>
    </Page>
  );
}

export default injectTransportationSearchParams(TransportationListScreen);



// WEBPACK FOOTER //
// ./src/screens/Transportation/TransportationList/TransportationListScreen.js